export function getRandomString(): string {
    return `rand${Math.floor(Math.random() * (9999999999999 - 1000000000000 + 1)) + 1000000000000}`;
}
